import { useContext } from 'react';
import {
  MapOverlayContext,
  MapOverlayMachineContextValue,
} from './MapOverlayMachineContext';

const useMapOverlayMachine = (): MapOverlayMachineContextValue => {
  const contextValue = useContext(MapOverlayContext);

  if (!contextValue) {
    throw new Error(
      'useMapOverlayMachine must be used within a MapOverlayMachineProvider'
    );
  }

  return contextValue as MapOverlayMachineContextValue;
};

export default useMapOverlayMachine;
